// extracted by mini-css-extract-plugin
module.exports = {"price-total":"_1t8qz6","linethrough":"_1LBMia","total":"_3q7600","discount-price":"BlEYp1","price-details":"_1gSsnI","coin-icon":"_1Psqkw"};